import { makeAutoObservable } from 'mobx';

import { navigateTo } from '@/common/helpers/navigateTo';
import useStore from '@/common/hooks/useStore';
import URLBuilder from '@/common/network/URLBuilder';
import Notifier from '@/common/services/Notifier';
import Storage, { KEY_URI_AFTER_TOP_UP } from '@/common/services/Storage';
import UserStore, { userStore } from '@/user/stores/UserStore';

import BillingAPI from '../api/BillingAPI';

export default class BillingStore {
  readonly billingAPI: BillingAPI;

  constructor(private readonly userStore: UserStore) {
    makeAutoObservable(this, {
      billingAPI: false,
    });

    this.billingAPI = new BillingAPI();
  }

  topUpBalance = (amount: string) => {
    return this.billingAPI.getPaymentEnroll(amount).then((response) => {
      /**
       * Save current location, after payment user will be redirected to result page, on result page we will take url from storage
       * and redirect user to his previous location
       *
       * Check "TopUpResult.tsx"
       * */
      if (response.content?.redirect) {
        Storage.saveObject(KEY_URI_AFTER_TOP_UP, window.location.href, Storage.STORAGE_SESSION);

        navigateTo(response.content.redirect);
      }
    });
  };

  showTopUpResult = async () => {
    const { success, error, ...restParams } = URLBuilder.params();

    if (!success && !error) {
      return;
    }

    URLBuilder.replaceQuery(restParams);

    if (error) {
      Notifier.error(error);
    }

    if (success) {
      Notifier.success(success);
    }

    await this.userStore.refreshUserInfo();
  };
}

export const useBillingStore = () => useStore(BillingStore);

export const billingStore = new BillingStore(userStore);
